var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var TrendingUp = function TrendingUp(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M21.648 6.238A1.006 1.006 0 0 1 22 7v7a1 1 0 0 1-2 0V9.414l-6.293 6.293a1 1 0 0 1-1.414 0L9 12.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l6-6a1 1 0 0 1 1.414 0L13 13.586 18.586 8H14a1 1 0 1 1 0-2h7a.998.998 0 0 1 .648.238Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default TrendingUp;